import '@wangeditor/editor/dist/css/style.css';

import { IDomEditor, IEditorConfig } from '@wangeditor/editor';
import { Editor } from '@wangeditor/editor-for-react';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';

import { customReport, CustomReportType } from '@/report/tam';

import styles from './index.module.less';
import { getParagraph } from './util';

const MyEditor: React.FC<{
  getList: (list: string[]) => void;
  disabled: boolean;
  setFocus?: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ getList, disabled, setFocus }) => {
  const createRef = useRef(false);
  const [editor, setEditor] = useState<IDomEditor | null>(null);
  const [html, _setHtml] = useState('');// 编辑器内容

  useEffect(() => {
    if (editor && !createRef.current) {
    }
  }, [editor]);

  // 编辑器配置
  const editorConfig: Partial<IEditorConfig> = {
    autoFocus: false,
    placeholder: `
     <div class='example'>
          <div class='example'>示例：</div>
          <div class='example'>
            <div class='example'>【旁白】二十年前的6月14日##配音名称</div>
            <div class='example'>【对话】默认选择开场任务第一个##配音名称</div>
            <div class='example'>【子涵】你好，我是子涵</div>
            <div class='example'>【背景图】：新增背景图</div>
            <div class='example'>【视频】新增视频</div>
            <div class='example'>【背景音乐】新增背景音乐</div>
            <div class='example'>【暂停背景音乐】暂停背景音乐</div>
          </div>
        </div>
        `,
    onFocus: () => {
      setFocus?.(true);
    },
    onBlur: () => {
      setFocus?.(false);
    },
  };
  // 及时销毁 editor ，重要！
  useEffect(() => () => {
    if (editor === null) return;
    if (editor) {
      // 销毁前先手动失去焦点
      editor?.blur();
      editor?.destroy();
      setEditor(null);
    }
  }, [editor]);

  const getValue = (editor: any) => {
    try {
      customReport(CustomReportType.MISSION_EXCL_INFO, {
        ['上报类型']: '剧情解析-输入信息',
        editor,
      });
      const list = editor.children;
      const newList = getParagraph(list);
      customReport(CustomReportType.MISSION_EXCL_INFO, {
        ['上报类型']: '剧情解析-输出信息',
        list: newList,
      });
      getList(newList);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={
          classNames(
            styles.drawer,
            { [styles.disabled]: disabled },
          )}
      >
        <Editor
          defaultConfig={editorConfig}
          value={html}
          onCreated={setEditor}
          onChange={editor => getValue(editor)}
          mode="simple"
          style={{ height: 'auto', overflowY: 'hidden', minHeight: '110px', width: '100%' }}
        />
      </div>
    </>
  );
};

export default MyEditor;
